/**
 * TopicList container
 * Left side topic list; Common Question is on the top for home page followed by topics list
 * Users can access leftside topic list from article, topic, and home page
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Glyph from 'kepler/lib/components/Glyph';
import { connect } from 'react-redux';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';
import { getPageUrlInfoFromLocation } from '../../lib/location-helper';
import urlResource from '../constants/UrlResources';

import getHistory from '../../lib/HistoryHelper';

const TopicList = (props) => {
  const { location, topics, isLoading, error, article, breadcrumb } = props;
  const FPTIId = Page.getFPTIPageId();

  const popular = {
    common: i18n.message('smarthelp/home.home.common'),
    recommended: i18n.message('smarthelp/home.home.recommended'),
    home: i18n.message('smarthelp/home.home.home'),
  };
  const pg = getPageUrlInfoFromLocation(location);

  const popularClass = classNames({
    'topic-tree-elements': true,
    'topic-selected': (pg.resource.name === urlResource.HOME),
  });

  const parentTopic = (currentArticle, breadcrumbs) => {
    if (Array.isArray(breadcrumbs) && breadcrumbs[1]) {
      return breadcrumbs[1].id;
    } else if (currentArticle && currentArticle.breadCrumbPath) {
      const topicTree = currentArticle.breadCrumbPath.split('/');
      return topicTree[1];
    }
    return null;
  };

  // FPTI tracking users' click behavior based on the triggered page
  const goToHome = () => {
    trackLink({ id: FPTIId, link: 'smarthelp-hcr-topic-list|common-questions' });
    getHistory().push('/home');
  };

  const goToTopicList = (e, topic) => {
    e.preventDefault();
    trackLink({ id: FPTIId, link: `smarthelp-hcr-topic-list|${topic.topicId}` });
    getHistory().push(`/topic/${topic.topicId}`);
  };

  const getTopicClass = (topic) => {
    if (pg.resource.name === urlResource.HOME || Page.isMobileLayout()) {
      return 'topic-tree-elements';
    } else if (pg.resource.name === urlResource.TOPIC && String(topic.topicId) === pg.resource.id) {
      return 'topic-tree-elements topic-selected';
    } else if (pg.resource.name === urlResource.ARTICLE && parentTopic(article, breadcrumb) === String(topic.topicId)) {
      return 'topic-tree-elements topic-selected';
    }
    return 'topic-tree-elements';
  };

  const getRecommendedPopularLabel = () => {
    if (Page.isLoggedIn()) {
      return popular.home;
    }
    return popular.common;
  };

  const getCommonQuestions = () => (
    <li className="topic-tree-elements-item topic-tree-elements-item__common-question">
      <button
        className={popularClass}
        onClick={() => goToHome()}
      >
        {getRecommendedPopularLabel()}
      </button>
    </li>
  );


  const getTopicList = () => topics.map(topic =>
    <li key={topic.topicId} className="topic-tree-elements-item">
      <a
        className={getTopicClass(topic)}
        key={topic.topicId}
        href={`/${Page.getCountry()}/smarthelp/topic/${topic.topicId}`}
        onClick={e => goToTopicList(e, topic)}
      >
        <div className="topic-tree-home-content">
          {topic.topicName}
        </div>
        <Glyph icon={Page.getArrowDirectionStyle()} className="icon-arrow" aria-hidden="true" />
      </a>

    </li>);

  const renderTopicTree = () => {
    if (!isLoading && !error) {
      return (
        <nav>
          <ul className="topic-tree-container-home">
            {getCommonQuestions()}
            {getTopicList()}
          </ul>
        </nav>
      );
    }
    return null;
  };
  return renderTopicTree();
};

function mapStateToProps(state) {
  return {
    isLoading: state.topicList.isLoading,
    topics: state.topicList.topics,
    location: state.location,
    error: state.topicList.error,
    article: state.article.article,
    breadcrumb: state.breadcrumb.items,
  };
}
TopicList.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.shape({
    topicId: PropTypes.string,
    topicName: PropTypes.string,
  })),
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
};

TopicList.defaultProps = {
  topics: [],
  display: false,
  location: undefined,
};
export default connect(mapStateToProps)(TopicList);
